import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ServiceLog} from "../../../../../classes/serviceLog";

@Component({
    selector: 'kan-service-logs-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanServiceLogsList {
    @Input() public logs: ServiceLog[];
    @Input() public searchText: string;
    @Input() public loading: boolean = false;
    @Output() public refresh: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/service-logs/list/component.ts